import React from 'react'
import PropTypes from 'prop-types'
import { Popover as AntDPopover } from 'antd'

const Popover = ({
  title,
  children,
  placement,
  trigger,
  arrowPointAtCenter,
  visible,
  className,
}) => (
  <AntDPopover
    content={title}
    placement={placement}
    trigger={trigger}
    arrowPointAtCenter={arrowPointAtCenter}
    visible={visible}
    overlayClassName={className}
  >
    {children}
  </AntDPopover>
)

Popover.defaultProps = {
  placement: 'top',
  trigger: 'hover',
  arrowPointAtCenter: true,
}

Popover.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.node,
    PropTypes.object,
  ]),
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.node,
    PropTypes.object,
    PropTypes.array,
  ]),
  placement: PropTypes.oneOf([
    'top',
    'left',
    'right',
    'bottom',
    'topLeft',
    'topRight',
    'bottomLeft',
    'bottomRight',
    'leftTop',
    'leftBottom',
    'rightTop',
    'rightBottom',
  ]),
  trigger: PropTypes.oneOf(['hover', 'click']),
  arrowPointAtCenter: PropTypes.bool,
  visible: PropTypes.bool,
  className: PropTypes.string,
}

export default Popover
